/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';


/*Components*/
import GetURLVar from '../../services/getParams/get-url-var';

/*Assets*/
import logo from '../../assets/images/logo.svg';




class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: "",
      adminData: {},
      sidebarCollape: false,
      purchasePlan: false,
      type: 1
    }
  }

  async componentWillMount() {
    this.findActiveItem();

    await GetURLVar().then(function (query) {
      console.log("inside GetURLVar");
      if (query.new) {

        this.setState({ purchasePlan: true });
      }
    }.bind(this));
    const sellerType = JSON.parse(localStorage.getItem("vendor_data")).seller_type;
    this.setState({ adminData: $.parseJSON(localStorage.getItem("u_data")), type: sellerType });
  }

  findActiveItem() {
    var tempUrl = [];
    tempUrl = window.location.href.split("/");
    this.setState({ activeItem: tempUrl[tempUrl.length - 1] });
  }

  navItemClick(item, tempPurchasePlan) {
    this.setState({ activeItem: item, purchasePlan: tempPurchasePlan });
    if(window.innerWidth<992) this.navToggle();
  }

  logout() {
    localStorage.clear();
    window.location.href = '/';
  }

  sidebarCollape(item) {
    this.props.collapse(!this.state.sidebarCollape);
    this.setState({ sidebarCollape: !this.state.sidebarCollape });
  }

  navToggle(){
    let currentState = this.state.navActive;
    this.setState({navActive: !currentState});
  }

  render() {
    return (
      <div className="e-sidebar">
        <div className="e-sidebar-logo px-4">
              <img src={logo} alt="ninja truck logo"/>
        </div>
        <div className={this.state.navActive? "e-burger e-burger-active d-lg-none":"e-burger d-lg-none"} onClick={()=>this.navToggle()}>
          <div className="e-filling-one"></div>
          <div className="e-filling-two"></div>
          <div className="e-filling-three"></div>
        </div>
        <div className={this.state.navActive? "e-sidebar-list-wrap p-4 e-sidebar-list-active": "e-sidebar-list-wrap p-4"}>
          <div className="e-sidebar-item pb-4">
            {
              this.state.activeItem === "dashboard" || this.state.activeItem === "" ?
                <Link className="e-sidebar-home e-active" onClick={this.navItemClick.bind(this, "dashboard")} to="/dashboard">Dashboard</Link>
                :
                <Link className="e-sidebar-home" onClick={this.navItemClick.bind(this, "dashboard")} to="/dashboard">Dashboard</Link>
            }
          </div>
          <div className="e-sidebar-item pb-4">
            {
              this.state.activeItem === "business" ?
                <Link className="e-sidebar-business e-active" onClick={this.navItemClick.bind(this, "business")} to="/business">My Business Listing</Link>
                :
                <Link className="e-sidebar-business" onClick={this.navItemClick.bind(this, "business")} to="/business">My Business Listing</Link>
            }
          </div>

          <div className="e-sidebar-item pb-4">
            {
              this.state.activeItem === "create-ads" ?
                <Link className="e-sidebar-create-ads e-active" onClick={this.navItemClick.bind(this, "create-ads")} to="/create-ads">Create Ad's</Link>
                :
                <Link className="e-sidebar-create-ads" onClick={this.navItemClick.bind(this, "create-ads")} to="/create-ads">Create Ad's</Link>
            }
          </div>

          <div className="e-sidebar-item pb-4">
            {
              this.state.activeItem === "create-offers" ?
                <Link className="e-sidebar-create-offers e-active" onClick={this.navItemClick.bind(this, "create-offers")} to="/create-offers">Create Offers</Link>
                :
                <Link className="e-sidebar-create-offers" onClick={this.navItemClick.bind(this, "create-offers")} to="/create-offers">Create Offers</Link>
            }
          </div>
          <div className="e-sidebar-item pb-4">
            {
              this.state.activeItem === "profile" ?
                <Link className="e-sidebar-users e-active" onClick={this.navItemClick.bind(this, "profile")} to="/profile">Profile</Link>
                :
                <Link className="e-sidebar-users" onClick={this.navItemClick.bind(this, "profile")} to="/profile">Profile</Link>
            }
          </div>

          <div className="e-sidebar-item pb-4">
            {
              this.state.activeItem === "invoices" ?
                <Link className="e-sidebar-payouts e-active" onClick={this.navItemClick.bind(this, "invoices")} to="/invoices">Invoices</Link>
                :
                <Link className="e-sidebar-payouts" onClick={this.navItemClick.bind(this, "invoices")} to="/invoices">Invoices</Link>
            }
          </div>

          <div className="e-sidebar-item pb-4">
            {
              this.state.activeItem === "ads-plans" ?
                <Link className="e-sidebar-ads-plans e-active" onClick={this.navItemClick.bind(this, "ads-plans")} to="/ads-plans">Manage Ads Plan</Link>
                :
                <Link className="e-sidebar-ads-plans" onClick={this.navItemClick.bind(this, "ads-plans")} to="/ads-plans">Manage Ads Plan</Link>
            }
          </div>
          <div className="e-sidebar-item pb-4">
            {
              this.state.activeItem === "purchase-plans?new=true" ?
                <Link className="e-sidebar-purchase-plans e-active" onClick={this.navItemClick.bind(this, "purchase-plans?new=true", true)} to="/purchase-plans?new=true">Purchase New Plan</Link>
                :
                <Link className="e-sidebar-purchase-plans" onClick={this.navItemClick.bind(this, "purchase-plans?new=true", true)} to="/purchase-plans?new=true">Purchase New Plan</Link>
            }
          </div>

          <div className="e-sidebar-item pb-4">
            {
              this.state.activeItem === "scheduled-ads" ?
                <Link className="e-sidebar-schecule e-active" onClick={this.navItemClick.bind(this, "scheduled-ads")} to="/scheduled-ads">Scheduled ads</Link>
                :
                <Link className="e-sidebar-schecule" onClick={this.navItemClick.bind(this, "scheduled-ads")} to="/scheduled-ads">Scheduled ads</Link>
            }
          </div>
          {
            this.state.type > 1 ?
              <React.Fragment>
                <div className="e-sidebar-item pb-4">
                  {
                    this.state.activeItem === "manage-products" ?
                      <Link className="e-sidebar-manage e-active" onClick={this.navItemClick.bind(this, "manage-products")} to="/manage-products">Manage Products / Services</Link>
                      :
                      <Link className="e-sidebar-manage" onClick={this.navItemClick.bind(this, "manage-products")} to="/manage-products">Manage Products / Services</Link>
                  }
                </div>

                <div className="e-sidebar-item pb-4">
                  {
                    this.state.activeItem === "all-enquires" ?
                      <Link className="e-sidebar-enquires e-active" onClick={this.navItemClick.bind(this, "all-enquires")} to="/all-enquires">All Enquires</Link>
                      :
                      <Link className="e-sidebar-enquires" onClick={this.navItemClick.bind(this, "all-enquires")} to="/all-enquires">All Enquires</Link>
                  }
                </div>

                <div className="e-sidebar-item pb-4">
                  {
                    this.state.activeItem === "store-layout" ?
                      <Link className="e-sidebar-store e-active" onClick={this.navItemClick.bind(this, "store-layout")} to="/store-layout">Store Layout</Link>
                      :
                      <Link className="e-sidebar-store" onClick={this.navItemClick.bind(this, "store-layout")} to="/store-layout">Store Layout</Link>
                  }
                </div>
              </React.Fragment>
              :
              null
          }
          <div className="e-sidebar-item pb-4 d-lg-none">
            {
              this.state.activeItem === "notification" ?
                <Link className="e-sidebar-notification-item e-active" onClick={this.navItemClick.bind(this, "notification")} to="/notification">Notification</Link>
              :
                <Link className="e-sidebar-notification-item" onClick={this.navItemClick.bind(this, "notification")} to="/notification">Notification</Link>
            }
          </div>
          <div className="e-sidebar-item pb-4 d-lg-none">
            <Link className="e-sidebar-logout-link" onClick={this.logout.bind(this)}>Logout</Link>
          </div>
        </div>
        <div className={this.state.navActive? "e-nav-backdrop e-nav-backdrop-active": "e-nav-backdrop"} onClick={()=>this.navToggle()}></div>
      </div>
    );
  }
}

export default Sidebar;
